import Api from '@/services/Api'

export default {
  addMember (payload) {
    return Api().post('user/member', payload)
  },
  getMember (payload) {
    return Api().post('user/member/get', payload)
  },
  verifyMember (payload) {
    return Api().post('user/member/verify', payload)
  },
  getUserName (query) {
    return Api().get(`user/name?id=${query}`)
  },
  upload (formData) {
    return Api().post('upload', formData)
  },
  createChip (payload) {
    return Api().post('items', payload)
  },
  checkToken (payload) {
    return Api().post('jwt', payload)
  },
  changePassword (payload) {
    return Api().post('changepassword', payload)
  },
  changePasswordSigned (payload) {
    return Api().post('changepasswordsigned', payload)
  },
  cancelPassword (payload) {
    return Api().post('changepassword/cancel', payload)
  },
  getFonts () {
    return Api().get('fonts', )
  }
}
